import { setResources } from "./bootstrapResources";
import serverReference from "./serverReference-de-DE.json";
import resources from "./translations-de-DE.json";

setResources(resources, serverReference);